module.exports = function () {

    $('.available-space-js-photo').click(function (e) {
        var $this = $(this),
            bck_img = $this.find('.available-space-details-photo').css('background-image'),
            mainWrapper = $('#js-available-space-photos-detail-wrapper'),
            mainPhoto = $('#js-available-space-main-photo'),
            img = bck_img.slice(5, -2);

        mainPhoto.attr('href', img);
        mainWrapper.find('.available-space-details-photo-main').css('background-image', bck_img);

        e.preventDefault();
    });

}();